import { isValid } from 'date-fns/isValid'
// eslint-disable-next-line no-restricted-imports -- this check grants the brand that parseDateFromISO requires
import { parseISO } from 'date-fns/parseISO'
import { logError } from 'lib/tracking/datadog'

const CALENDAR_DAY = /^\d{4}-\d{2}-\d{2}$/

export const isISODate = (value: string): value is ISODate => CALENDAR_DAY.test(value) && isValid(parseISO(value))

export const asISODate = (value: string): ISODate => {
  if (isISODate(value)) {
    return value
  }

  const error = new TypeError(`asISODate expected a calendar date (YYYY-MM-DD), received ${JSON.stringify(value)}`)

  if (process.env.NODE_ENV === 'production') {
    logError(error)
    return value as ISODate
  }

  throw error
}
